<template>
  <div class="page">
    <template v-if="list && list.length">
      <div class="page-c3">
        <div class="page-c3-one" v-for="(item, index) in list" :key="index">
          <div class="top-man">
            <div class="top-man-l">
              <img v-if="item.exhibitor && item.exhibitor.company.logo" :src="item.exhibitor.company.logo" />
              <img v-else src="@/assets/img/empty.png" />
            </div>
            <div class="top-man-r">
              <div class="comp_name">{{ item.exhibitor && item.exhibitor.company.name }}</div>
            </div>
          </div>
          <div class="top-info">
            <p class="con">
              <span class="u-brand s-bule-border">{{ item.type }}</span
              >{{ item.content }}
            </p>
            <div class="top-time">
              <p>
                <span class="state-no" v-if="item.auditState == -1">未通过</span>
                <span class="state-ing" v-else-if="item.auditState == 0">审核中</span>
                <span class="state-nore" v-else-if="item.state == 0">未回应</span>
                <span class="state-no" v-else-if="item.state == 2">已拒绝</span>
              </p>
              <p v-if="item.auditState == -1 || item.state == 2">
                <Poptip confirm title="确认删除吗?" transfer @on-ok="delItem(item.id)">
                  <span class="del">删除</span>
                </Poptip>
                <span v-if="item.auditState == -1" class="edit" @click="edit(item)">重新编辑</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="no_more mar2_4" v-else>还没有提交过预约洽谈</div>
    <orderModal ref="orderModal" @finish="getData"></orderModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import orderModal from "@components/orderModal/index.vue";
export default {
  name: "not-respond",
  data() {
    return {
      list: [],
    };
  },
  components: {
    orderModal,
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      user: "getUser",
    }),
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      graphqlPost: "graphqlPostByZXS",
      delOrder: "user/delOrder",
    }),
    async getData() {
      let query = `
        query($query:QueryInput!){
          exhibitorAppointmentQuery{
            query(query:$query){
              hasNextPage
              pageIndex
              totalCount
              items{
                companyUsersId
                content
                createAt
                exhibitionId
                exhibitorId
                id
                exhibitor{
                  company{
                    logo
                    name
                  }
                }
                customerService{
                  id
                  name
                  nickName
                  phone
                  jobTitle
                  company  
                  email
                }
                member{
                  name
                  nickName
                  phone
                  jobTitle
                  company
                  avatarUrl
                  email
                }
                memberId
                state
                type
                auditState
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "memberId",
          v: this.user.inMember.memberId,
        },
        EqualA: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        NotEqualB: {
          n: "state",
          v: 1,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt = {
        query: query,
        variables: {
          query: {
            page: 1,
            size: 4,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
      let data = await this.graphqlPost(opt);
      let res = JSON.parse(JSON.stringify(data.data.exhibitorAppointmentQuery.query));
      this.list = res.items;
    },
    //删除
    async delItem(id) {
      let res = await this.delOrder(id);
      if (res.result) {
        this.getData();
        this.$Message.success("删除成功");
      } else {
        this.$Message.error(res.message);
      }
    },
    edit(e) {
      this.$refs.orderModal.open(e);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@assets/scss/my-theme/mixin.scss";
.page {
  &-c3 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &-one {
      padding: 10px;
      background: #f7f7f7;
      border-radius: 3px;
      width: 310px;
      height: 160px;
      margin: 0 0 20px 0;
      border: solid 1px #f7f7f7;
      position: relative;
      &:hover {
        cursor: pointer;
        @include border_color(#1890ff);
      }
      .top {
        &-man {
          display: flex;
          margin-bottom: 8px;
          &-l {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            margin-right: 10px;
            img {
              display: block;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          &-r {
            max-width: calc(100% - 36px);
            .comp_name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #666;
              font-size: 12px;
              line-height: 26px;
            }
          }
        }
        &-info {
          .con {
            line-height: 1.8;
            height: 75px;
            min-height: 75px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            text-align: justify;
          }
          .u-brand {
            height: 20px;
          }
          span {
            margin-right: 10px;
            line-height: 1.5;
          }
        }
        &-time {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 24px;
          margin-top: 5px;
          p {
            color: #999;
            font-size: 12px;
            display: flex;
            align-items: center;
            span {
              margin-right: 10px;
            }
            .state-ing {
              color: #ff5e00;
            }
            .state-nore {
              color: #1890ff;
            }
            .state-no {
              color: #666;
            }
            .del {
              color: #ff5e00;
              cursor: pointer;
            }
            .edit {
              width: 64px;
              height: 24px;
              @include background_color(#1890ff);
              border-radius: 3px;
              color: #fff;
              text-align: center;
              display: inline-block;
              line-height: 24px;
              margin-right: 0;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
